import { useTranslation as e } from "../../i18n/hooks.js";
import { Calendar as t } from "../primitive/calendar.js";
import { DateField as n } from "../primitive/date-field.js";
import { DateModeEnum as r } from "../types/date-mode-enum.js";
import { Popup as i } from "../primitive/popup.js";
import { useDateFnsLocale as a } from "../utils/use-date-fns-locale.js";
import { useDate as o } from "./use-date.js";
import { useState as s } from "react";
import { jsx as c } from "react/jsx-runtime";
import { enUS as l } from "date-fns/locale/en-US";
//#region src/date-picker/date-picker/date-picker.tsx
function u({ clearable: u, description: d, disabled: f, error: p, intlLocale: m, label: h, labelClassName: g, maxDate: _, minDate: v, mode: y = r.DateSince, onChange: b, placeholder: x, required: S, size: C, timezone: w, value: T, wrapperButtonInputClassName: E }) {
	let { t: D } = e(), [O, k] = s(l);
	a(m, k);
	let [A, j] = s(!1), { appliedDate: M, applyDate: N, selectedDate: P, setSelectedDate: F } = o({
		mode: y,
		onChange: b,
		timezone: w,
		value: T
	}), I = (() => {
		if (M) return new Intl.DateTimeFormat(m, {
			day: "2-digit",
			month: "long",
			year: "numeric"
		}).format(M);
	})(), L = () => {
		j(!1);
	};
	return /* @__PURE__ */ c(i, {
		disabled: f,
		onOpenChange: (e) => {
			j(e), e || F(M);
		},
		open: A,
		trigger: /* @__PURE__ */ c(n, {
			clearable: u,
			description: d,
			disabled: f,
			error: p,
			focus: A,
			label: h,
			onClear: () => {
				N(null), L();
			},
			placeholder: x ?? D("public_pages_purchase.date_picker.date_placeholder"),
			required: S,
			size: C,
			value: I,
			labelClassName: g,
			className: E
		}),
		triggerRender: /* @__PURE__ */ c("div", {
			"aria-label": h ? void 0 : x ?? D("public_pages_purchase.date_picker.date_placeholder"),
			className: "group/date-field-trigger w-full text-left",
			role: "button",
			tabIndex: 0
		}),
		children: /* @__PURE__ */ c(t, {
			intlLocale: m,
			locale: O,
			maxDate: _,
			minDate: v,
			onChange: (e) => {
				if (e instanceof Date) {
					if (M && e.toDateString() === M.toDateString()) {
						N(null), L();
						return;
					}
					N(e), L();
				}
			},
			selected: P
		})
	});
}
//#endregion
export { u as DatePicker };
